export const TOGGLE_DRAWER = "TOGGLE_DRAWER"
export const TOGGLE_CONFIRM_MODAL = "TOGGLE_CONFIRM_MODAL"
export const SET_CONFIRM_MODAL_CONTENT = "SET_CONFIRM_MODAL_CONTENT"
export const SET_BREADCRUMBS = "SET_BREADCRUMBS"
export const SET_LOADING = "SET_LOADING"
